import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsControl({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M10 10.2c.28 0 .5.22.5.5v.4h2.75c.14 0 .25.11.25.25v.7c0 .14-.11.25-.25.25H10.5v.4a.5.5 0 01-.5.5H8a.5.5 0 01-.5-.5v-.4H2.75a.25.25 0 01-.25-.25v-.7c0-.14.11-.25.25-.25H7.5v-.4c0-.28.22-.5.5-.5h2zM5 6.5c.28 0 .5.22.5.5v.4h7.75c.14 0 .25.11.25.25v.7c0 .14-.11.25-.25.25H5.5V9a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5V7c0-.28.22-.5.5-.5h2zm8-3.7c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-.4H2.75a.25.25 0 01-.25-.25v-.7c0-.14.11-.25.25-.25h7.75v-.4c0-.28.22-.5.5-.5h2z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgSettingsControl.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsControl.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgSettingsControl svgRef={ref} {...props} />);
export default ForwardRef;
